import React from 'react';
import { TrendingUpIcon, PackageIcon, ShoppingCartIcon, AlertCircleIcon, ArrowUpIcon, ArrowDownIcon, RotateCcwIcon, TagIcon, ClipboardListIcon, BarChart3Icon } from 'lucide-react';
export const DealerDashboard = () => {
  // Sample data for the dashboard
  const kpis = [{
    title: "Today's Sales",
    value: '$1,245.89',
    change: '+12.5%',
    isIncrease: true,
    icon: <TrendingUpIcon className="h-6 w-6 text-blue-600" data-id="element-2413" />
  }, {
    title: 'Pending Orders',
    value: '12',
    change: '-2 orders',
    isIncrease: false,
    icon: <ShoppingCartIcon className="h-6 w-6 text-amber-600" data-id="element-2414" />
  }, {
    title: 'Low Stock Items',
    value: '8',
    change: '+3 items',
    isIncrease: false,
    icon: <PackageIcon className="h-6 w-6 text-red-600" data-id="element-2415" />
  }, {
    title: 'Return Requests',
    value: '3',
    change: 'No change',
    isIncrease: true,
    icon: <RotateCcwIcon className="h-6 w-6 text-purple-600" data-id="element-2416" />
  }];
  const recentOrders = [{
    id: 'ORD-12345',
    customer: 'John Smith',
    date: '2023-05-15',
    amount: '$234.50',
    status: 'Processing'
  }, {
    id: 'ORD-12344',
    customer: 'Sarah Johnson',
    date: '2023-05-15',
    amount: '$129.99',
    status: 'Shipped'
  }, {
    id: 'ORD-12343',
    customer: 'Michael Brown',
    date: '2023-05-14',
    amount: '$89.00',
    status: 'Delivered'
  }, {
    id: 'ORD-12342',
    customer: 'Emma Wilson',
    date: '2023-05-14',
    amount: '$345.75',
    status: 'Processing'
  }, {
    id: 'ORD-12341',
    customer: 'David Lee',
    date: '2023-05-13',
    amount: '$78.50',
    status: 'Delivered'
  }];
  const inventoryAlerts = [{
    product: 'iPhone 14 Pro - 256GB - Black',
    stock: 2,
    threshold: 5,
    status: 'Critical'
  }, {
    product: 'Samsung Galaxy S23 - 128GB - Gray',
    stock: 3,
    threshold: 5,
    status: 'Low'
  }, {
    product: 'iPad Air 5th Gen - 64GB - Silver',
    stock: 4,
    threshold: 5,
    status: 'Low'
  }, {
    product: 'MacBook Air M2 - 256GB - Space Gray',
    stock: 0,
    threshold: 3,
    status: 'Out of Stock'
  }];
  const quickActions = [{
    title: 'Add Product',
    icon: <PackageIcon className="h-5 w-5" data-id="element-2417" />,
    color: 'bg-blue-100 text-blue-700'
  }, {
    title: 'Create Coupon',
    icon: <TagIcon className="h-5 w-5" data-id="element-2418" />,
    color: 'bg-green-100 text-green-700'
  }, {
    title: 'View Reports',
    icon: <ClipboardListIcon className="h-5 w-5" data-id="element-2419" />,
    color: 'bg-purple-100 text-purple-700'
  }, {
    title: 'Manage Orders',
    icon: <ShoppingCartIcon className="h-5 w-5" data-id="element-2420" />,
    color: 'bg-amber-100 text-amber-700'
  }];
  return <div className="space-y-6" data-id="element-2421">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-2422">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2423">Dealer Dashboard</h1>
        <div className="mt-3 sm:mt-0" data-id="element-2424">
          <select className="border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-white focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-2425">
            <option data-id="element-2426">Today</option>
            <option data-id="element-2427">Yesterday</option>
            <option data-id="element-2428">Last 7 days</option>
            <option data-id="element-2429">This month</option>
            <option data-id="element-2430">Last month</option>
          </select>
        </div>
      </div>
      {/* KPI Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2431">
        {kpis.map((kpi, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-6 border border-gray-200" data-id="element-2432">
            <div className="flex justify-between items-start" data-id="element-2433">
              <div data-id="element-2434">
                <p className="text-sm font-medium text-gray-500" data-id="element-2435">{kpi.title}</p>
                <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-2436">
                  {kpi.value}
                </p>
              </div>
              <div className="p-3 rounded-full bg-gray-50" data-id="element-2437">{kpi.icon}</div>
            </div>
            <div className="flex items-center mt-4" data-id="element-2438">
              {kpi.change !== 'No change' && <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${kpi.isIncrease ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-2439">
                  {kpi.isIncrease ? <ArrowUpIcon className="h-3 w-3 mr-1" data-id="element-2440" /> : <ArrowDownIcon className="h-3 w-3 mr-1" data-id="element-2441" />}
                  {kpi.change}
                </span>}
              {kpi.change === 'No change' && <span className="text-xs text-gray-500" data-id="element-2442">No change</span>}
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2443">
        {/* Sales Chart */}
        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200 lg:col-span-2" data-id="element-2444">
          <div className="flex justify-between items-center mb-6" data-id="element-2445">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-2446">
              Sales (Last 30 Days)
            </h2>
            <button className="text-gray-400 hover:text-gray-500" data-id="element-2447">
              <BarChart3Icon className="h-5 w-5" data-id="element-2448" />
            </button>
          </div>
          {/* Placeholder for chart */}
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-2449">
            <p className="text-gray-400" data-id="element-2450">Sales Chart Placeholder</p>
          </div>
        </div>
        {/* Quick Actions */}
        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200" data-id="element-2451">
          <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-2452">
            Quick Actions
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-2453">
            {quickActions.map((action, index) => <button key={index} className="flex flex-col items-center p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-2454">
                <div className={`p-3 rounded-full ${action.color} mb-2`} data-id="element-2455">
                  {action.icon}
                </div>
                <span className="text-sm font-medium text-gray-700" data-id="element-2456">
                  {action.title}
                </span>
              </button>)}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2457">
        {/* Recent Orders */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-2458">
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-2459">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-2460">Recent Orders</h2>
            <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-2461">
              View all
            </a>
          </div>
          <div className="overflow-x-auto" data-id="element-2462">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-2463">
              <thead className="bg-gray-50" data-id="element-2464">
                <tr data-id="element-2465">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2466">
                    Order ID
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2467">
                    Customer
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2468">
                    Date
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2469">
                    Amount
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2470">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-2471">
                {recentOrders.map(order => <tr key={order.id} className="hover:bg-gray-50" data-id="element-2472">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-2473">
                      {order.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-2474">
                      {order.customer}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2475">
                      {order.date}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-2476">
                      {order.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2477">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${order.status === 'Delivered' ? 'bg-green-100 text-green-800' : order.status === 'Processing' ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-2478">
                        {order.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {/* Inventory Alerts */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-2479">
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-2480">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-2481">
              Inventory Alerts
            </h2>
            <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-2482">
              View inventory
            </a>
          </div>
          <div className="overflow-x-auto" data-id="element-2483">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-2484">
              <thead className="bg-gray-50" data-id="element-2485">
                <tr data-id="element-2486">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2487">
                    Product
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2488">
                    Stock
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2489">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-2490">
                {inventoryAlerts.map((item, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-2491">
                    <td className="px-6 py-4 text-sm text-gray-900" data-id="element-2492">
                      {item.product}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-2493">
                      {item.stock} / {item.threshold}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2494">
                      <span className={`px-2 inline-flex items-center text-xs leading-5 font-semibold rounded-full ${item.status === 'Critical' ? 'bg-red-100 text-red-800' : item.status === 'Low' ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2495">
                        {item.status === 'Critical' || item.status === 'Out of Stock' ? <AlertCircleIcon className="h-3 w-3 mr-1" data-id="element-2496" /> : null}
                        {item.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};